<template>
    <div id="jornada-wrapper">
        <section id="jornada" class="position-relative">
            <div class="container d-lg-flex align-items-lg-center pt-lg-4">
              <div class="py-5 mx-auto col-md-12 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                  <div class="px-0 pt-5 py-lg-3 col-md-5 mx-md-4">
                    <img src="/images/landing-pages/jornada/marca.svg" alt="Jornada Scriv" class="mx-auto ml-md-0 d-block" width="250"/>
                    <p class="mt-4 mb-1 font-size-small date text-md-left text-center d-flex align-items-center text-nowrap">
                      <img src="/images/landing-pages/jornada/ico-calendar.svg" alt="Calendar Icon" class="mr-2" />
                      05 DE NOVEMBRO DE 2022 | DAS 14H ÀS 18H30
                    </p>
                    <p class="mt-1 mb-1 font-size-small date text-md-left text-center d-flex align-items-center text-nowrap">
                      <img src="/images/landing-pages/jornada/ico-location.svg" alt="Calendar Icon" class="mr-2" />
                      EXPO SCRIV <span class="font-size-xSmall ml-1">(Espaço exclusivo no Metaverso)</span>
                    </p>
                    <p class="writers font-size-large font-weight-bold my-2 text-md-left text-center">
                      A bienal do livro <br />
                      online para autores<br/>
                      <span class="highlighted highlight-right">independentes</span>
                    </p>
                    <p class="mb-4 circle-outline font-weight-light font-size-small text-center mt-3">Online e gratuito</p>
                    <p class="mt-2 mb-0 initiative font-weight-light font-size-small text-md-left text-center d-flex align-items-center justify-content-center justify-content-md-start">Uma iniciativa <img src="/images/layout/logo-white.png" class="ml-2 mb-1"/> </p>
                    <p class="mt-4 mt-md-1 initiative biblion font-weight-light text-md-left text-center d-md-flex align-items-center justify-content-center justify-content-md-start">Apoio e Participação <img src="/images/landing-pages/jornada/biblion-pb.png" class="ml-md-2 mb-1"></p>
                  </div>
                  <div class="px-0 col-md-6 paper-bg mx-md-4">
                    <h2 class="title font-weight-bold text-center mt-5 mb-md-4 pt-md-4 pt-5 text-color2">FAÇA SUA INSCRIÇÃO!</h2>
                    <form
                      class="py-4 px-5 col-md-10 mx-md-auto default-form"
                      action=""
                      method="POST"
                      @submit.prevent="submit('form')"
                    >
                      <div class="row px-3">
                          <div class="col-md-12">
                          <div class="form-group">
                              <input type="text" class="default-input" placeholder="Nome" :readonly="loader" v-model.trim="$v.form.name.$model" />
                          </div>
                          </div>
                          <div class="col-md-12">
                          <div class="form-group">
                              <input type="email" class="default-input" placeholder="Email" :readonly="loader" v-model.trim="$v.form.email.$model" />
                          </div>
                          </div>
                      </div>

                      <div class="text-center mt-3">
                          <Button
                          type="submit"
                          class="btn-lg btn-primary font-size-small off-color"
                          :loading="loader"
                          >
                          Garanta sua vaga
                          </Button>
                      </div>
                    </form>
                  </div>
              </div>
            </div>
            <img src="/images/landing-pages/jornada/ico-arrow-down.svg" alt="Navegue para baixo" class="arrow" />
            <video id="video-bg" preload="auto" autoplay="true" loop="loop" muted="muted" volume="0">
                <source src="/images/landing-pages/jornada/bg-write.mp4" type="video/mp4">
            </video>
        </section>
        <section id="expo">
          <div class="container d-lg-flex align-items-lg-center">
            <div class="content flex-wrap d-flex px-lg-5 px-3 py-4">
              <div class="py-1 mx-auto col-12 col-md-5 text-center text-lg-left">
                <h2 class="font-weight-bold mb-md-4 pt-md-4 pt-lg-5 text-color2">EXPO SCRIV</h2>
                <p>A <strong>Expo Scriv</strong>, nosso espaço exclusivo no Metaverso, foi criada especialmente para a Jornada Scriv. Com capacidade para até 800 pessoas, o ambiente é <strong>completamente interativo</strong>, podendo ser utilizado sem a instalação de qualquer software ou aplicativo.</p>
                <p>Para entrar na Expo Scriv, cada participante deve <strong>se cadastrar</strong> e então acessar o link que será via email alguns dias antes do evento. Ao entrar, seu <strong>avatar personalizado</strong> deve ser criado e sua participação nas atividades do evento já pode começar!</p>
              </div>
              <div class="py-5 mx-auto col-12 col-md-7 d-flex align-items-center">
                <video id="video-expo" controls loop autoplay muted="muted" class="mx-auto">
                  <source src="/images/landing-pages/jornada/gt.mp4" type="video/mp4">
                </video>
              </div>
            </div>
          </div>
        </section>
        <section id="palestrantes">
          <div class="container align-items-lg-center">
            <h2 class="font-weight-bold text-center mx-auto mt-md-5 mt-1 mb-5 pt-md-4 pt-5 text-color2">PALESTRANTES</h2>
            <div class="col-12 row mx-auto">
              <div class="card mb-5 mx-auto" v-for="p in palestrantes" :key="p.name">
                <img class="card-img-top" :src="p.src" :alt="p.name">
                <div class="card-body text-center text-lg-left">
                  <h5 class="card-title px-2 font-weight-bold text-color2">{{p.name}}</h5>
                  <p class="card-text px-2">{{p.desc}}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="autores" class="py-5">
          <div class="container align-items-lg-center py-md-4 py-2">
            <div class="row">
              <h2 class="col-12 font-weight-bold text-center mx-auto mb-5 text-color2">AUTORES EXPOSITORES</h2>
              <div class="col-md-3 col-6 my-2 mx-auto author-base" v-for="a in autores" :key="a.name">
                <img :src="a.src" />
                <div class="img-overlay">
                  <div class="text-overlay">
                    <a v-if="a && a.profile" :href="a.profile" target="_blank" class="overlay-link">
                      {{a.name}}
                    </a>
                    <span v-else>
                      {{a.name}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="programacao">
          <div class="container align-items-lg-center text-white">
            <div class="row">
              <h2 class="font-weight-bold col-12 text-center mx-auto mt-5 mb-3 pt-md-4 pt-3">PROGRAMAÇÃO</h2>
              <div class="col-12 mx-auto my-2">
                <div class="d-flex flex-wrap d-block d-md-none">
                  <div class="col-12 mx-auto my-3 text-center mob-program">
                    <h3 class="text-center mb-4"><span class="font-weight-bold">EXPERIÊNCIAS</span><br>(Stand e Lounges)</h3>
                    <p class="font-weight-bold py-2">14h00 - Abertura do evento</p>
                    <p class="font-weight-bold py-2">14h30 ~ 16h30 - Stand dos autores/parceiros</p>
                    <p class="font-weight-bold py-2">17h00 ~ 17h30 - Bate-papo aberto</p>
                    <p class="font-weight-bold py-2">18h30 - Sorteios de brindes exclusivos, agradecimentos e encerramento oficial do evento</p>
                  </div>
                  <div class="col-12 mx-auto my-3 text-center mob-program">
                    <h3 class="text-center mb-4"><span class="font-weight-bold">DEBATES LITERÁRIOS</span><br>(Auditório Lispector)</h3>
                    <div class="font-weight-bold py-2 mob-authors two-authors">
                      <img src="/images/landing-pages/jornada/palestras/Leandro-Navatta.png" alt="Leandro Navatta" />
                      <img src="/images/landing-pages/jornada/palestras/Malu-Costacurta.png" alt="Malu Costacurta" />
                      <p class="mt-2">15h00 - O Poder dos e-books, com Leandro Navatta e Malu Costacurta</p>
                    </div>
                    <div class="font-weight-bold py-2 mob-authors two-authors">
                      <img src="/images/landing-pages/jornada/palestras/Clara-Alves.png" alt="Clara Alves" />
                      <img src="/images/landing-pages/jornada/palestras/Pedro-Rhuas.png" alt="Pedro Rhuas" />
                      <p class="mt-2">16h30 - Quebrando Paradigmas Literários, com Clara Alves e Pedro Rhuas</p>
                    </div>
                  </div>
                  <div class="col-12 mx-auto my-3 text-center mob-program">
                    <h3 class="text-center mb-4"><span class="font-weight-bold">PALESTRAS</span><br>(Auditório Barreto)</h3>
                    <div class="font-weight-bold py-2 mob-authors">
                      <img src="/images/landing-pages/jornada/palestras/Mandi-Castro.png" alt="Mandi Castro" />
                      <p class="mt-2">15h30 - Palestra: Mandi Castro</p>
                    </div>
                    <div class="font-weight-bold py-2 mob-authors">
                      <img src="/images/landing-pages/jornada/palestras/Gabi-Lopes.png" alt="Gabi Lopes" />
                      <p class="mt-2">17h30 - Palestra: Gabi Lopes</p>
                    </div>
                  </div>
                </div>
                <div class="table-responsive d-md-block d-none">
                  <table class="text-color1 w-100">
                    <thead>
                      <tr class="text-white text-nowrap">
                        <th width="100">&nbsp;</th>
                        <th>
                          <h3 class="text-center"><span class="font-weight-bold">EXPERIÊNCIAS</span><br>(Stand e Lounges)</h3>
                        </th>
                        <th>
                          <h3 class="text-center"><span class="font-weight-bold">DEBATES LITERÁRIOS</span><br>(Auditório Lispector)</h3>
                        </th>
                        <th>
                          <h3 class="text-center"><span class="font-weight-bold">PALESTRAS</span><br>(Auditório Barreto)</h3>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center px-4 px-lg-0">14h00</td>
                        <td class="font-weight-bold text-color1 px-4 px-lg-0">Abertura do evento</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">14h30</td>
                        <td class="font-weight-bold text-color1">Stand dos autores/parceiros</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">15h00</td>
                        <td class="font-weight-bold text-color1">Stand dos autores/parceiros</td>
                        <td>
                          <div class="d-flex align-items-center text-left justify-content-center min-width-authors">
                            <div class="mr-2 two-authors">
                              <img src="/images/landing-pages/jornada/palestras/Leandro-Navatta.png" alt="Leandro Navatta" />
                              <img src="/images/landing-pages/jornada/palestras/Malu-Costacurta.png" alt="Malu Costacurta" />
                            </div>
                            <div>
                              <span class="font-weight-bold">O poder dos e-books</span><br />Com Leandro Navatta e Malu Costacurta
                            </div>
                          </div>
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">15h30</td>
                        <td class="font-weight-bold text-color1">Stand dos autores/parceiros</td>
                        <td>
                          &nbsp;
                        </td>
                        <td>
                          <div class="d-flex align-items-center text-left justify-content-center px-4 px-lg-0">
                            <div class="mr-2">
                              <img src="/images/landing-pages/jornada/palestras/Mandi-Castro.png" alt="Mandi Castro" />
                            </div>
                            <div>
                              Palestra <span class="font-weight-bold">Mandi Castro</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">16h00</td>
                        <td class="font-weight-bold text-color1">Stand dos autores/parceiros</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">16h30</td>
                        <td class="font-weight-bold text-color1">Bate-papo aberto</td>
                        <td>
                          <div class="d-flex align-items-center text-left justify-content-center">
                            <div class="mr-2 two-authors">
                              <img src="/images/landing-pages/jornada/palestras/Clara-Alves.png" alt="Clara Alves" />
                              <img src="/images/landing-pages/jornada/palestras/Pedro-Rhuas.png" alt="Pedro Rhuas" />
                            </div>
                            <div>
                              <span class="font-weight-bold">Quebrando Paradigmas Literários</span><br />Com Clara Alves e Pedro Rhuas
                            </div>
                          </div>
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">17h00</td>
                        <td class="font-weight-bold text-color1">Bate-papo aberto</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">17h30</td>
                        <td class="font-weight-bold text-color1">Bate-papo aberto</td>
                        <td>&nbsp;</td>
                        <td>
                          <div class="d-flex align-items-center text-left justify-content-center">
                            <div class="mr-2">
                              <img src="/images/landing-pages/jornada/palestras/Gabi-Lopes.png" alt="Gabi Lopes" />
                            </div>
                            <div>
                              Palestra <span class="font-weight-bold">Gabi Lopes</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr class="text-left text-nowrap">
                        <td class="font-weight-bold text-color2 text-center">18h30</td>
                        <td class="font-weight-bold text-color1" colspan="3">Sorteios de brindes exclusivos, agradecimentos e encerramento oficial do evento</td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="como-surgiu">
          <div class="container pb-5">
            <div class="">
              <h2 class="font-weight-bold col-12 text-center mx-auto mt-5 mb-5 text-color2">COMO SURGIU A JORNADA?</h2>
              <div class="d-flex flex-wrap flex-lg-nowrap mt-4 pt-lg-5">
                <div class="col-12 col-md-6 mb-5 column p-5 mr-3">
                  <div class="column-icon">
                    <img src="/images/landing-pages/jornada/block.png"/>
                  </div>
                  <p class="mt-4 text-color1">As <span class="font-weight-bold text-color2">Bienais do Livro</span> de São Paulo e do Rio de Janeiro foram as grandes inspirações para este projeto.</p>
                  <p class="text-color1">Entretanto, esses incríveis eventos possuem algumas <span class="font-weight-bold text-color2">limitações</span> muito relevantes:</p>
                  <ul class="pl-3">
                    <li><span class="font-weight-bold text-color2">Baixa periodicidade</span> (a cada 2 anos)</li>
                    <li><span class="font-weight-bold text-color2">Alta lotação nos stands</span> (difícil locomoção)</li>
                    <li><span class="font-weight-bold text-color2">Custos elevados</span> (ingressos + logística + alimentação)</li>
                    <li><span class="font-weight-bold text-color2">Exclusivos para SP e RJ</span> (e os outros Estados?)</li>
                  </ul>
                </div>
                <div class="col-12 col-md-6 mb-5 column p-5">
                  <div class="column-icon">
                    <img src="/images/landing-pages/jornada/check.png"/>
                  </div>
                  <p class="mt-4 text-color1">Para <span class="font-weight-bold text-color2">resolver as limitações</span> dos eventos literários tradicionais, era preciso inovar em todos os sentidos.</p>
                  <p class="text-color1">Desta maneira, criamos um evento social, sem fins lucrativos, totalmente inclusivo e democrático:</p>
                  <ul class="pl-3">
                    <li><span class="font-weight-bold text-color2">Com alta periodicidade</span> (a cada 6 meses)</li>
                    <li><span class="font-weight-bold text-color2">Sem lotações</span> (evento integralmente online)</li>
                    <li><span class="font-weight-bold text-color2">Gratuito para todos</span> (sem custos ou taxas)</li>
                    <li><span class="font-weight-bold text-color2">Para todos os estados</span> (no Brasil e no mundo)</li>
                  </ul>
                </div>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-primary mx-auto my-3 p-4" v-b-modal.patrocinios>QUERO SER UM PARCEIRO OU PATROCINADOR</button>
              </div>
            </div>
          </div>
        </section>
        <section id="horizontal-inscricao">
          <div class="container align-items-lg-center py-5">
            <div class="">
              <h2 class="font-weight-bold text-center text-white w-100 mb-4">FAÇA A SUA INSCRIÇÃO</h2>
              <form
                class="py-4 px-5 mx-md-auto d-lg-flex align-items-lg-center"
                action=""
                method="POST"
                @submit.prevent="submit('horizontal')"
              >
                <div class="col">
                  <div class="form-group mb-lg-0">
                      <input type="text" class="default-input" placeholder="Nome" :readonly="loader" v-model.trim="$v.horizontalForm.name.$model" />
                  </div>
                </div>
                <div class="col">
                  <div class="form-group mb-lg-0">
                      <input type="email" class="default-input" placeholder="Email" :readonly="loader" v-model.trim="$v.horizontalForm.email.$model" />
                  </div>
                </div>
                <div class="text-center">
                  <Button
                  type="submit"
                  class="btn-lg btn-primary font-size-small off-color mt-3 mt-lg-0"
                  :loading="loader"
                  >
                  Garanta sua vaga
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </section>
        <section id="faq">
          <div class="container d-lg-flex align-items-lg-center">
              <div class="py-5 mx-auto col-md-12 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
                  <div class="px-0 py-md-5 py-3 col-md-5 mx-md-4 text-center text-lg-left">
                    <img src="/images/landing-pages/jornada/faq.png" />
                    <h2 class="title font-weight-bold mt-1 mb-md-4 text-color2">PERGUNTAS <br class="d-md-block" />FREQUENTES</h2>
                    <p class="text-color1">Restou alguma dúvida? Envie um email <br class="d-md-block" />para <strong>contato@scriv.com.br</strong></p>
                  </div>
                  <div class="px-0 py-md-5 py-0 col-md-6 mx-md-4">
                    <div class="accordion" role="tablist">
                      <div
                        no-body
                        class="py-2 px-4 accordion-item m-3"
                        v-for="(question, index) in faq"
                        :key="index"
                      >
                        <div class="accordion-header" v-b-toggle="`accordion-2-${index}`">
                          <h4 class="font-weight-bold text-color2">{{ question.question }}</h4>
                        </div>
                        <b-collapse :id="`accordion-2-${index}`" accordion="my-accordion" role="tabpanel">
                          <div>
                            <div v-html="question.answer"></div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
        </section>
        <b-modal
          id="patrocinios"
          modal-class="default-modal modal-xLarge"
          body-class="background-white"
          :hide-footer="true"
          ref="patrocinios"
        >
          <template v-slot:modal-title>
            <span class="font-size-large">PATROCÍNIOS</span>
          </template>

          <div class="d-flex flex-wrap flex-lg-nowrap text-color1">
            <div class="cota-block col-12 col-md-6 mb-3">
              <div class="d-flex flex-column flex-lg-row align-items-center">
                <div class="mb-4" style="flex-shrink: 0;">
                  <img src="/images/landing-pages/jornada/cota-ouro.png" alt="Cota Ouro" />
                </div>
                <div>
                  <h4 class="font-weight-bold text-center text-lg-start">COTA OURO</h4>
                  <ul class="pl-5 pl-lg-3">
                    <li><span class="font-weight-bold text-color2">Naming rights</span> do evento</li>
                    <li><span class="font-weight-bold text-color2">Stand principal</span> na Expo Scriv</li>
                    <li><span class="font-weight-bold text-color2">Logotipo destacado</span> em todos os materiais de comunicação online</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="cota-block col-12 col-md-6 mb-3">
              <div class="d-flex flex-column flex-lg-row align-items-center">
                <div class="mb-4" style="flex-shrink: 0;">
                  <img src="/images/landing-pages/jornada/cota-prata.png" alt="Cota Prata" />
                </div>
                <div>
                  <h4 class="font-weight-bold text-center text-lg-start">COTA PRATA</h4>
                  <ul class="pl-5 pl-lg-3">
                    <li><span class="font-weight-bold text-color2">Palestra</span> patrocinada</li>
                    <li><span class="font-weight-bold text-color2">Stand exclusivo</span> na Expo Scriv</li>
                    <li><span class="font-weight-bold text-color2">Logotipo aplicado</span> em todos os materiais de comunicação online</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap flex-lg-nowrap text-color1">
            <div class="cota-block col-12 col-md-6 mb-3">
              <div class="d-flex flex-column flex-lg-row align-items-center">
                <div class="mb-4" style="flex-shrink: 0;">
                  <img src="/images/landing-pages/jornada/cota-bronze.png" alt="Cota Bronze"/>
                </div>
                <div>
                  <h4 class="font-weight-bold text-center text-lg-start">COTA BRONZE</h4>
                  <ul class="pl-5 pl-lg-3">
                    <li>Participação em <span class="font-weight-bold text-color2">debate</span></li>
                  <li><span class="font-weight-bold text-color2">Stand padrão</span> na Expo Scriv</li>
                  <li><span class="font-weight-bold text-color2">Logotipo</span> como apoiador na comunicação online do evento</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="cota-block col-12 col-md-6 mb-3">
              <div class="d-flex flex-column flex-lg-row align-items-center">
                <div class="mb-4" style="flex-shrink: 0;">
                  <img src="/images/landing-pages/jornada/cota-branca.png" alt="Cota Branca"  />
                </div>
                <div>
                  <h4 class="font-weight-bold text-center text-lg-start text-nowrap">COTA BRANCA <span class="font-size-xSmall font-weight-regular">(Apenas ONGs)</span></h4>
                  <ul class="pl-5 pl-lg-3">
                    <li>Participação em <span class="font-weight-bold text-color2">debate</span></li>
                    <li><span class="font-weight-bold text-color2">Stand padrão</span> na Expo Scriv</li>
                    <li><span class="font-weight-bold text-color2">Logotipo</span> como apoiador na comunicação online do evento</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap flex-lg-nowrap text-color1">
            <div class="col-12 text-center">
              <p class="text-color1">Entre em contato com <a href="mailto:anna.luiza@scriv.com.br" class="link-color2">anna.luiza@scriv.com.br</a></p>
            </div>
          </div>
        </b-modal>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

import NotificationService from '@/modules/notifications/services/notifications-service'
import StaticsService from '@/modules/statics/services/statics-service'
import Button from '@/components/common/Button/Button.vue'

export default {
  components: {
    Button
  },
  metaInfo: {
    title: 'Jornada Scriv',
    meta: [
      { vmid: 'description', name: 'description', content: 'Conheça a Jornada Scriv, o primeiro evento literário feito para escritores independentes. Faça sua inscrição para participar online e gratuitamente.' },
      { vmid: 'og-description', name: 'og:description', content: 'Conheça a Jornada Scriv, o primeiro evento literário feito para escritores independentes. Faça sua inscrição para participar online e gratuitamente.' }
    ]
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        source: 'JORNADA_SCRIV_2022'
      },
      horizontalForm: {
        name: '',
        email: '',
        source: 'JORNADA_SCRIV_2022'
      },
      palestrantes: [
        { src: '/images/landing-pages/jornada/palestras/Gabi-Lopes.png', name: 'Gabi Lopes', desc: 'Autora do livro “Antes Feito do Que Perfeito: Mas Nunca Mal Feito”, Gabi Lopes é escritora,  atriz, apresentadora e uma das maiores influenciadoras digitais do Brasil.' },
        { src: '/images/landing-pages/jornada/palestras/Pedro-Rhuas.png', name: 'Pedro Rhuas', desc: 'Autor de “Enquanto Eu Não Te Encontro”, Pedro Rhuas é escritor e jornalista. Suas narrativas falam sobre protagonismo LGBTQIAP+ e as potências de um Nordeste vivo.' },
        { src: '/images/landing-pages/jornada/palestras/Mandi-Castro.png', name: 'Mandi Castro', desc: 'Autora de “Martim Lafayette e o Contra-Tempo”, Mandi Castro é escritora e atriz, finalista em 2021 no Prêmio Minuano de Literatura e no Prêmio Odisséia Fantástica.' },
        { src: '/images/landing-pages/jornada/palestras/Clara-Alves.png', name: 'Clara Alves', desc: 'Autora de “Conectadas” e “Romance Real”, Clara Alves é escritora best seller com mais de 100 mil livros vendidos. Seu primeiro romance LGBTQIAP+ figurou por várias semanas consecutivas na lista de mais vendidos da Veja.' },
        { src: '/images/landing-pages/jornada/palestras/Malu-Costacurta.png', name: 'Malu Costacurta', desc: 'Mente fantasiosa por trás de “Constelação” e “Baía do Braz”, Malu Costacurta é escritora independente e viciada em fantasias com tramas políticas.' },
        { src: '/images/landing-pages/jornada/palestras/Leandro-Navatta.png', name: 'Leandro Navatta', desc: 'Autor de “Histórias de um Alguém”, Leandro Navatta é escritor, palestrante, empresário e um dos fundadores da Scriv, plataforma de publicação brasileira.' }
      ],
      autores: [
        { src: '/images/landing-pages/jornada/autores/Mariana-Lucioli.png', name: 'Mariana Lucioli' },
        { src: '/images/landing-pages/jornada/autores/Leblon-Carter.png', name: 'Leblon Carter' },
        { src: '/images/landing-pages/jornada/autores/Maria-Freitas.png', name: 'Maria Freitas', profile: 'https://scriv.com.br/themariafreitas/' },
        { src: '/images/landing-pages/jornada/autores/Jo-Melo.png', name: 'Jô Melo', profile: 'https://scriv.com.br/jomelo/' },
        { src: '/images/landing-pages/jornada/autores/Gabriela-Lagemann.png', name: 'Gabriela Lagemann', profile: 'https://scriv.com.br/glagemann/' },
        { src: '/images/landing-pages/jornada/autores/Ricardo-Garcia.png', name: 'Ricardo Garcia', profile: 'https://scriv.com.br/ricardogarciaautor/' },
        { src: '/images/landing-pages/jornada/autores/Maira-Gomes.png', name: 'Maíra Gomes', profile: 'https://scriv.com.br/mairagomes/' },
        { src: '/images/landing-pages/jornada/autores/Maycon-Guedes.png', name: 'Maycon Guedes', profile: 'https://scriv.com.br/mayconguedes/' },
        { src: '/images/landing-pages/jornada/autores/Sandra-Oneil.png', name: "Sandra O'Neill", profile: 'https://scriv.com.br/sandra-oneill/' },
        { src: '/images/landing-pages/jornada/autores/Rafael-Weschenfelder.png', name: 'Rafael Weschenfelder' },
        { src: '/images/landing-pages/jornada/autores/Rosa-Scarlett.png', name: 'Rosa Scarlett', profile: 'https://scriv.com.br/rosa-scarlett/' },
        { src: '/images/landing-pages/jornada/autores/Giulianno-Liberalli.png', name: 'Giulianno Liberalli', profile: 'https://scriv.com.br/giulianno/' },
        { src: '/images/landing-pages/jornada/autores/Bruno-Neves.png', name: 'Bruno Neves', profile: 'https://scriv.com.br/bruno-neves/' },
        { src: '/images/landing-pages/jornada/autores/Juliana-Salvatori.png', name: 'Juliana Salvatori', profile: 'https://scriv.com.br/gnoma-bionica/' },
        { src: '/images/landing-pages/jornada/autores/Eduardo-Marques.png', name: 'Eduardo Marques', profile: 'https://scriv.com.br/eduardo-means-lina/' },
        { src: '/images/landing-pages/jornada/autores/Joao-Victor.png', name: 'João Victor', profile: 'https://scriv.com.br/victor-gomes/' }
      ],
      faq: [
        {
          question: 'O que é a Jornada Scriv?',
          answer: '<p style="color: #1d1d1d">A Jornada Scriv é um evento online e gratuito, inspirado pela Bienal do Livro de São Paulo, mas com foco em autores independentes e leitores de todo o Brasil. O evento acontecerá no dia 05 de novembro das 14h às 18h30 na Expo Scriv, nosso espaço no Metaverso.</p>'
        },
        {
          question: 'Como faço para participar?',
          answer: '<p style="color: #1d1d1d">Para participar da Jornada Scriv, basta fazer sua inscrição clicando <a href="https://scriv.com.br/jornada" target="_blank" class="link-color2" class="link-color2">aqui</a>. Alguns dias antes do evento, você receberá um e-mail com o convite para entrar no Gather Town, plataforma online que sediará o evento. A partir disso, você irá criar um avatar personalizado para começar sua interação no espaço e curtir todas as experiências do evento.</p>'
        },
        {
          question: 'Posso comprar livros durante o evento?',
          answer: '<p style="color: #1d1d1d">Sim! Todos os autores que terão stands na Jornada Scriv estarão vendendo suas obras digitais, disponibilizando o link para compra para todos os visitantes.</p>'
        },
        {
          question: 'O que é Gather Town?',
          answer: '<p style="color: #1d1d1d">É a plataforma digital onde foi construída a Expo Scriv, local onde será realizada a Jornada Scriv. Para utilizá-la não é necessário instalar nenhum aplicativo ou criar nenhuma conta, basta acessar o link que será enviado por e-mail após seu cadastro no evento.</p>'
        },
        {
          question: 'Como vou interagir com o evento?',
          answer: '<p style="color: #1d1d1d">Uma vez que seu avatar estiver criado e você estiver dentro da Expo Scriv, sua interação no evento tem início. Basta mover seu personagem com as teclas (cima, baixo, direita e esquerda) do seu teclado ou clicar com o botão esquerdo do mouse para seu local de destino. Ao se aproximar de objetos, você pode apertar “X” para interagir com eles, descobrindo os links, imagens e vídeos que estarão expostos. Além disso, para interagir com outros convidados, se aproxime deles e uma conversa de áudio e vídeo irá começar.</p>'
        },
        {
          question: 'O que são os stands e como eles funcionam?',
          answer: '<p style="color: #1d1d1d">Os stands são áreas personalizadas criadas para os parceiros da Jornada Scriv e nossos autores convidados. Nessas áreas, são criadas automaticamente zonas de conversas em áudio e vídeo, para que os participantes possam interagir entre si, além de terem acesso exclusivo aos livros digitais que os autores irão expor.</p>'
        },
        {
          question: 'Quais são os auditórios do evento e o que acontecerá neles?',
          answer: '<p style="color: #1d1d1d">Na Expo Scriv existem dois auditórios: o Auditório Lispector e o Auditório Barreto. No primeiro, teremos dois debates literários com autores independentes nacionais, sendo os temas “O Poder dos E-Books” e “Quebrando Paradigmas Literários”. No segundo, acontecerão as duas principais palestras do evento, por Mandi Castro e Gabi Lopes.</p>'
        }
      ],
      loader: false
    }
  },
  validations () {
    return {
      form: {
        name: { required },
        email: { required, email }
      },
      horizontalForm: {
        name: { required },
        email: { required, email }
      }
    }
  },
  methods: {
    async submit (origin) {
      this.loader = true
      try {
        await StaticsService.storeLead(this.form)
        const notification = {
          notification: {
            type: 'success',
            content: 'Registrado com sucesso!'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        if (origin === 'form') {
          this.form.name = ''
          this.form.email = ''
        } else {
          this.horizontalForm.name = ''
          this.horizontalForm.email = ''
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}

</script>

<style lang="scss" scoped>
  #jornada-wrapper {
    background: #fff;
    margin-bottom: -50px;
    color: $color1;
    .text-color1{
      color: $color1 !important;
    }
  }

  #jornada {
    font-family: $font1;
    margin: -50px 0;
    background-color: #F6F6F6;
    position: relative;

    video {display: none;}

    @include desktop {
      position: relative;
      width: 100vw;
      overflow: hidden;
      min-height: 750px;
      margin: -50px 0 -130px;

      video {
        display: block;
        position: absolute;
        top: 0;
        z-index: 1;
        width: 100%;
        height: auto;
      }
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      background-image: url('/images/landing-pages/jornada/BG1.png');
    }

    .container {
      position: relative;
      z-index: 3;
    }

    .arrow {
      display: none;

      position: absolute;
      bottom: 0;
      left: calc(50% - 15px);
      width: 30px;
      height: 30px;
      z-index: 4;

      @include desktop {
        bottom: 170px;
        display: block;
      }
    }

    .container{
      .paper-bg {
        background-image: url('/images/landing-pages/jornada/form-bg.svg');
        background-size: cover;
        background-position: center;
        height: 450px;
        .title{
          font-size: 20px;
          color: $color2;
        }

        form {
          input {
            border: none;
            border-radius: 0;
            border-bottom: 1px solid rgb(206, 212, 218);
            font-size: 14px;
            width: 100%;
            color: $color1;
            padding: 10px;

            &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
              color: $color1 !important;
              opacity: .8; /* Firefox */
            }

            &:-ms-input-placeholder { /* Internet Explorer 10-11 */
              color: $color1 !important;
            }

            &::-ms-input-placeholder { /* Microsoft Edge */
              color: $color1 !important;
            }

            &:hover, &:active, &:focus{
              border-bottom: 1px solid $color2;
            }
          }
          .off-color {
            color: #fff;
            border-radius: 8px;
            padding: 20px 70px;
            text-transform: uppercase;
            @include desktop {
              padding: 20px 30px;
            }
            &:hover, &:active, &:focus {
              border-color: $color2;
              color: $color2;
            }
          }
        }
      }

      .date{
        color: $color1 !important;
      }

      .writers {
        color: #fff;
        text-transform: uppercase;
        position: relative;
        z-index: 2;
        line-height: 39px;
        .highlighted{
          z-index: -1;
          &::before{
            background: $color1;
            width: calc(100% + 10px);
            height: 20px;
            bottom: 0;
            transform: none;
          }

          &.highlight-left::before {
            right: -5px;
          }

          &.highlight-right::before {
            left: -5px;
          }

        }
      }

      .circle-outline{
        padding: 5px;
        border: 1px solid #fff;
        border-radius: 20px;
        width: 180px;
        text-transform: uppercase;
        color: #fff;
        margin: 0 auto;
        display: block;
        @include desktop {
          margin: 0;
        }
      }

      .initiative{
        color: #fff;
        text-transform: uppercase;
        img{
          vertical-align: middle;
          margin-left: 7px;
          width: 100px;
        }
        &.biblion{
          font-size: 11px;
          img{
            width: 300px;
            display: block;
            position: relative;
            margin: 0 auto;
            @include desktop{
              width: 250px;
              margin: -18px;
            }
          }
        }
      }
    }
  }

  #expo{
      position: relative;
      @include desktop{
        &::before {
          content: '';
          position: absolute;
          top: 140px;
          left: -100px;
          width: 378px;
          height: 492px;
          background: url('/images/landing-pages/jornada/bg-expo-left.png');
          background-size: 100% auto;
          background-repeat: no-repeat;
        }

        &::after {
          content: '';
          position: absolute;
          top: -80px;
          right: -130px;
          width: 542px;
          height: 710px;
          background: url('/images/landing-pages/jornada/bg-expo-right.png');
          background-size: 100% auto;
          background-repeat: no-repeat;
        }
      }

    .container{
      position: relative;
      z-index: 2;
      .content{
        position: relative;
        background-color: #fff;
        border-radius: 20px;
        -webkit-box-shadow: 16px 30px 60px 0 rgba(0,0,0,0.01);
        box-shadow: 16px 30px 60px 0 rgba(0,0,0,0.04);

        video{
          width: 100%;
          border-radius: 10px;
          -webkit-box-shadow: 0 3px 30px 0 rgba(0,0,0,0.2);
          box-shadow: 0 3px 30px 0 rgba(0,0,0,0.2);
        }
        p{
          color: $color1;
          font-size: 16px;
        }
      }
    }
  }

  #palestrantes{
    .container{
      .card{
        border: none;
        border-radius: 5px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0,0,0,0.15);
        box-shadow: 0 5px 20px 0 rgba(0,0,0,0.15);

        @include desktop{
          width: calc(32% - 10px);
        }

        .card-img-top {
          border-radius: 5px;
        }

        .card-text{
         color: $color1;
         font-size: 16px;
        }
      }
    }
  }

  #autores{
    background: #F8F8F8;
    .container{
      .author-base {
        position: relative;
        img {
          display: block;
          width: 100%;
          max-width: 200px;
          height: auto;
          border-radius: 100px;
        }

        .img-overlay {
          position: absolute;
          top: 6%;
          bottom: 0;
          left: 12%;
          right: 0;
          height: 100%;
          width: 100%;
          opacity: 0;
          transition: .5s ease;
          background-color: $color2;
          border-radius: 100px;
          max-height: 170px;
          max-width: 170px;
          @include desktop{
            top: 3%;
            left: 7%;
            max-height: 190px;
            max-width: 190px;
          }
          .text-overlay {
            a, span{
              color: white;
              font-size: 16px;
              position: absolute;
              top: 50%;
              left: 50%;
              -webkit-transform: translate(-50%, -50%);
              -ms-transform: translate(-50%, -50%);
              transform: translate(-50%, -50%);
              text-align: center;
              @include desktop{
                font-size: 18px;
              }
            }
          }
        }

        &:hover .img-overlay {
          @include desktop {
            opacity: 0.9;
          }
        }
      }
    }
  }

  #programacao{
    background-image: url('/images/landing-pages/jornada/BG1-full.jpg');
    .container{
      .mob-program{
        h3{
          span{
            font-size: 23px;
          }
          font-size: 16px;
        }
      }
      .mob-authors{
        img{
          width: 90px;
          border-radius: 45px;
        }
        &.two-authors{
          img:first-child {
            margin-right: -10px;
          }
        }
      }

      table{
        border-collapse: separate;
        border-spacing: 0 20px;
        thead{
          h3{
            span{
              font-size: 18px;
            }
            font-size: 14px;
          }
        }
        tbody{
          tr{
            font-size: 15px;
            td{
              background: rgba(255,255,255,0.7);
              padding: 20px 0;
              vertical-align: middle;
              &.text-color1{
                color: $color1;
              }

              img {
                border-radius: 100px;
                width: 46px;
                height: 46px;
                -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
                box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
                max-width: none;
              }

              .two-authors {
                img:first-child {
                  margin-right: -10px;
                }
              }

              .min-width-authors {
                min-width: 450px;
                @include desktop {
                  min-width: auto;
                }
              }
            }
            td:first-child { border-top-left-radius: 10px; border-bottom-left-radius: 10px; }
            td:last-child { border-top-right-radius: 10px; border-bottom-right-radius: 10px;}
          }
        }
      }
    }
  }

  #como-surgiu{
    position: relative;

    @include desktop{
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -230px;
        width: 542px;
        height: 710px;
        background: url('/images/landing-pages/jornada/bg-expo-right.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
      }

      &::after {
        content: '';
        position: absolute;
        top: 90px;
        right: -180px;
        width: 542px;
        height: 710px;
        background: url('/images/landing-pages/jornada/bg-expo-right.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
    }
    .container {
      position: relative;
      z-index: 2;
    }

    ul{
      li{
        list-style-type: disc;
        &::marker{
          color: $color2;
        }
      }
    }

    .column {
      background:#F8F8F8;
      border-radius: 30px;
      position: relative;

      .column-icon {
        background: #fff;
        border-radius: 150px;
        padding: 15px;
        display: inline-block;
        position: absolute;
        top: -44px;
        left: calc(50% - 44px);
      }
    }
  }

  #horizontal-inscricao{
    background-image: url('/images/landing-pages/jornada/BG1-full.jpg');
    form {
      input {
        background: transparent;
        border: none;
        border-radius: 0;
        border-bottom: 1px solid rgb(206, 212, 218);
        font-size: 16px;
        color: #fff;
        padding: 10px;

        @include desktop {
          width: 300px;
        }

        &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #fff !important;
          opacity: .8; /* Firefox */
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #fff !important;
        }

        &::-ms-input-placeholder { /* Microsoft Edge */
          color: #fff !important;
        }

        &:hover, &:active, &:focus{
          border-bottom: 1px solid $color1;
        }
      }
      .off-color {
        background-color: #fff;
        border-color: #fff;
        color: $color2;
        border-radius: 8px;
        padding: 20px 20px;
        text-transform: uppercase;

        @include desktop {
          padding: 20px 70px;
        }

        &:hover, &:active, &:focus {
          border-color: $color2;
          background-color: $color2;
          color: #fff;
        }
      }
    }
  }

  #faq{
    .accordion-item{
      border: 2px solid $color2;
      border-radius: 25px;
      .accordion-header{
        &.not-collapsed {
          h4::after {
            content: '-';
          }
        }

        h4{
          font-size: 19px;
          margin-bottom: 0;
          position: relative;
          padding-right: 20px;

          &::after {
            content: '+';
            position: absolute;
            right: 0;
            top: -2px;
            color: $color2;
            font-size: 20px;
            font-weight: bold;
          }
        }
      }

      .collapse.show {
        padding-top: 15px;
      }
    }
  }

  ::v-deep #patrocinios{
    .text-color1{ color:$color1 !important; }
    .modal-content {
      background-color: #fff !important;
    }

    .modal-header {
      background-color: #fff !important;
    }

    .modal-body{
      .cota-block{
        padding: 20px 0;
        border: 2px solid $color2;
        border-radius: 19px;
        margin: auto 5px;
        font-size: 16px;
        @include desktop{
          padding: 20px 35px;
        }
        img {
          width: 50px;

          @include desktop {
            width: 66px;
          }
        }

        ul{
          li{
            list-style: disc;
            &::marker{
              color: $color2;
            }
          }
        }
      }
    }
  }
</style>
